<template>
  <div class="screenView info-page-wrapper">
    <header class="hero-section">
      <img src="@/assets/img/CA_Logo_black.png" alt="Chess Administrator" class="hero-logo">
      <h1 class="hero-title">{{ $t('info.about.heroTitle') }}</h1>
      <p class="hero-subtitle">{{ $t('info.about.heroSubtitle') }}</p>
      <router-link to="/sign-up" class="button-default btn-cta">{{ $t('info.about.signUpAndStart') }}</router-link>
      <br/>
      <br/>
      <br/>
      <p><router-link to="/" class="center">{{ $t('info.about.justGo') }}</router-link></p>
    </header>

    <main class="mainView">
      <section class="intro-text">
        <h2>{{ $t('info.about.moreThanJustResults') }}</h2>
        <p>{{ $t('info.about.more1') }}</p>
      </section>

      <section class="zz-row">
        <div class="zz-text">
          <h3 class="accent-blue">{{ $t('info.about.yourChessCareer') }}</h3>
          <p>{{ $t('info.about.career1') }}</p>
        </div>
        <div class="zz-image">
          <div class="screenshot-frame">
            <div class="dummy-content"><img src="@/assets/img/UsingCA.png" alt="Using Chess Administrator" class="screenshot-img" /></div>
          </div>
        </div>
      </section>

      <section class="zz-row reverse">
        <div class="zz-text">
          <h3 class="accent-blue">{{ $t('info.about.neverMissAMove') }}</h3>
          <p>{{ $t('info.about.miss1') }}</p>
        </div>
        <div class="zz-image">
          <div class="screenshot-frame">
            <div class="dummy-content"><img src="@/assets/img/ResultsEverywhere.png" alt="Results everywhere" class="screenshot-img" /></div>
          </div>
        </div>
      </section>

      <section class="zz-row">
        <div class="zz-text">
          <h3 class="accent-blue">{{ $t('info.about.organizeProfessional') }}</h3>
          <p>{{ $t('info.about.organize1') }}</p>
        </div>
        <div class="zz-image">
          <div class="screenshot-frame">
            <div class="dummy-content"><img src="@/assets/img/ArbiterAtWork.png" alt="Arbiter at work" class="screenshot-img" /></div>
          </div>
        </div>
      </section>

      <section class="final-cta">
        <h2>{{ $t('info.about.readyToMakeYourMove') }}</h2>
        <div class="bottom-bar">
          <div class="column"> <router-link to="/sign-in" class="button-default btn-cta">{{ $t('info.about.memberLoginHere') }}</router-link></div>
            <router-link to="/" class="button-default btn-cta">{{ $t('info.about.goToStart') }}</router-link>
          <div class="column">
            <router-link to="/sign-up" class="button-default btn-cta">{{ $t('info.about.createFreeAccount') }}</router-link>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'About',
  beforeMount() {
    // Show only once for each visitor
    localStorage.setItem('hideChessSplash', 'true');      
  },
}

</script>


<style scoped>
/* Algemene Layout */
.info-page-wrapper {
  background-color: #1F1F1F;
  color: #E5E5E5;
}

.column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex:1;
}

.checkbox {
  width: 16px;
  height: 16px;
} 

.bottom-bar {
  display: flex;
}

.mainView {
  flex-grow: 1;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.screenshot-img {
  width: 100%;
  height: 100%;
  
  /* Dit is de magie: */
  object-fit: cover; 
  
  /* Optioneel: zorgt dat het midden van de foto altijd centraal staat */
  object-position: center; 
  
  /* Omdat het frame een border heeft, wil je misschien dat de foto 
     iets 'achter' de rand ligt, dit voorkomt dat hij eroverheen bloedt */
  display: block; 
}

/* Hero Sectie */
.hero-section {
  text-align: center;
  padding: 80px 20px;
  background: radial-gradient(circle at center, #2a4b7c 0%, #1F1F1F 70%);
}

.hero-logo {
  max-width: 25vw;
  height: auto;
  margin-bottom: 25px;
}

.hero-title {
  font-size: 2.5em;
  color: #eee;
  margin-bottom: 10px;
}

.hero-subtitle {
  font-size: 1.2em;
  color: #8fabd6;
  margin-bottom: 30px;
}

/* Zig-Zag Rijen */
.zz-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 0;
  gap: 40px;
}

.zz-row.reverse {
  flex-direction: row-reverse;
}

.zz-text {
  flex: 1;
}

.zz-image {
  flex: 1;
  display: flex;
  justify-content: center;
}

.accent-blue {
  color: #5681c2;
  font-size: 1.8em;
  margin-bottom: 15px;
}

/* Screenshot Frames */
.screenshot-frame {
  width: 100%;
  max-width: 450px;
  aspect-ratio: 16 / 10;
  background: #2a2a2a;
  border: 1px solid #3c6591;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.screenshot-frame:hover {
  transform: translateY(-5px);
  border-color: #f5d997;
}

.dummy-content {
  color: #72777e;
  font-style: italic;
}

/* Secties */
.intro-text {
  text-align: center;
  padding: 40px 0;
  max-width: 800px;
  margin: 0 auto;
}

.final-cta {
  text-align: center;
  padding: 80px 0;
  border-top: 1px solid #3a3a3a;
}

/* Knoppen */
.btn-cta {
  display: inline-block;
  padding: 12px 30px;
  font-size: 1.1em;
  font-weight: bold;
  height: auto;
  color: #111d2f !important;
  width: fit-content;
  margin-top: 4px;
  align-self: center;
}

.small-link {
  font-size: 0.9em;
}

.center {
  align-self: center;
}

/* Mobile Responsive */
@media screen and (max-width: 768px) {
  .zz-row, .zz-row.reverse {
    flex-direction: column;
    text-align: center;
    padding: 40px 0;
  }
  
  .hero-title {
    font-size: 1.8em;
  }
}
</style>


